import { render, staticRenderFns } from "./LibrarySaveChangesButtons.vue?vue&type=template&id=230eda36"
import script from "./LibrarySaveChangesButtons.vue?vue&type=script&lang=js"
export * from "./LibrarySaveChangesButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports